module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"label":"不確定哪個尺寸合適？{link}查看 AI 推薦的尺寸！","label_link":"點擊這裡"}}')
  delete Component.options._Ctor
}
